import { render } from "./BankCard.vue?vue&type=template&id=fb808c04&scoped=true&ts=true"
import script from "./BankCard.vue?vue&type=script&lang=ts"
export * from "./BankCard.vue?vue&type=script&lang=ts"

import "./BankCard.vue?vue&type=style&index=0&id=fb808c04&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb808c04"]])

export default __exports__